<template>
    <div
        class="w-full flex justify-center pb-6 lg:pb-16"
        v-observe-visibility="visibilityChanged"
    >
        <div
            class="container flex flex-col items-center lg:flex-row py-8 lg:py-14"
        >
            <div
                class="w-full lg:w-1/2 pr-8 py-12 text-center lg:text-left px-8"
            >
                <img
                    v-devise-image="{
                        image: devise.logoImage,
                        breakpoint: breakpoint,
                    }"
                    v-if="devise.logoImage.url"
                    style="max-height: 80px"
                />
                <h3
                    v-if="devise.title.text"
                    class="font-sans-lato font-light text-3xl mb-4"
                >
                    {{ devise.title.text }}
                </h3>
                <div v-html="devise.description.text"></div>
            </div>
            <div
                class="relative w-full lg:w-1/2 mx-8 lg:mx-0"
                style="min-height: 350px"
            >
                <div
                    class="absolute top-0 right-0 -mr-16 mt-48 "
                    style="
                        width: 482px;
                        height: 287px;
                        background-image: url('/imgs/collection/beach-tb-fade.png');
                    "
                ></div>
                <div class="absolute top-0 left-0 mt-24 two-pane-image1 shadow">
                    <img
                        class="block"
                        v-devise-image="{
                            image: devise.image1,
                            breakpoint: breakpoint,
                        }"
                        v-if="devise.image1.url"
                    />
                </div>
                <div
                    class="absolute top-0 left-0 ml-48 mt-0 two-pane-image2 shadow-lg"
                >
                    <img
                        class="block"
                        v-devise-image="{
                            image: devise.image2,
                            breakpoint: breakpoint,
                        }"
                        v-if="devise.image2.url"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import anime from 'animejs/lib/anime.es.js';

export default {
    name: 'TwoPaneTextImage',

    data() {
        return {
            isVisible: false,
        };
    },

    mounted() {
        anime({
            targets: ['.two-pane-image1', '.two-pane-image2'],
            translateX: 5000,
            opacity: 0,
            duration: 2000,
        });
    },

    methods: {
        visibilityChanged(isVisible) {
            this.isVisible = isVisible;

            if (this.isVisible) {
                anime({
                    targets: ['.two-pane-image1', '.two-pane-image2'],
                    translateX: 0,
                    opacity: 1,
                    duration: 3000,
                    easing: 'easeOutExpo',
                    delay: anime.stagger(200),
                });
            } else {
                anime({
                    targets: ['.two-pane-image1', '.two-pane-image2'],
                    translateX: 5000,
                    opacity: 0,
                    duration: 2000,
                });
            }
        },
    },
};
</script>
